import React from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {styled} from '@mui/system';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import {setTextValue} from "../store/reducers/TextValue";
import {HeadingText} from "./StyledComponents";
import MuiInput from '@mui/material/Input';
import EditTextPanel from "../Layouts/SubPanels/TextTabs/EditTextPanel";

const Input = styled(MuiInput)`
  width: 42px;
`;

const MaxHeightTextarea = styled(TextareaAutosize)`
  resize: none;
  overflow-y: auto !important;
  max-height: 15em;
  min-height: 3em;
  padding: 1em;
  width: 90%;
  border: 1px solid #ccc;
  border-radius: 8px;
  font-family: Arial, sans-serif;
  font-size: 14px;
  line-height: 1.5;
  
   &:hover {
    border-color: #888;
    box-shadow: 0 0 3px rgba(0, 0, 0, 0.3);
  }
`;

function TextProperties() {
    const {canvas} = useSelector((state) => state.canvas);
    const {activeObject} = useSelector((state) => state.canvas);
    const {textValue} = useSelector((state) => state.textValue);

    const dispatch = useDispatch()


    const handleChange = (event) => {
        if (activeObject && activeObject.type === 'textbox') {
            dispatch(setTextValue(event.target.value))
            activeObject.set('text', event.target.value);
            activeObject.setCoords();
            canvas.renderAll();
        }
    };



    return (
        <div className="text-properties-wrapper mt-3">
            <HeadingText>Text Field</HeadingText>
            <MaxHeightTextarea
                rows={3}
                maxRows={15}
                value={textValue}
                onChange={handleChange}
                aria-label="maximum height textarea"
            />
            <hr className="solid-divider"/>
            <EditTextPanel />
        </div>
    );
}

export default TextProperties;
